import { render } from "./AudioToggle.vue?vue&type=template&id=9e63ee6c&scoped=true"
import script from "./AudioToggle.vue?vue&type=script&lang=js"
export * from "./AudioToggle.vue?vue&type=script&lang=js"

import "./AudioToggle.vue?vue&type=style&index=0&id=9e63ee6c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\niso\\Documents\\repos\\medrina-everhouse-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e63ee6c"]])

export default __exports__